'use client';

import { useCallback, type MouseEvent } from 'react';
import { useGlobalContextMenu } from '../../hooks/useGlobalContextMenu';
import type { ApplicationSettingsTabId } from '../../store/application-settings-tab-id';
import { GlobalMenuItemsTypeEnum } from '../../store/globalContextMenuStore';
import { useMainContentTabs } from '../../store/layoutStore';
import { setApplicationSettingsSubTabOnActiveTab } from '../../utils/setMainContentSettingsSubTab';
import { sidebarTabMapping } from '../layout/utils';

export function useOpenTargetSettings() {
  const { navigateInActiveTab } = useMainContentTabs();
  const { openContextMenu } = useGlobalContextMenu();

  const openSettings = useCallback(
    (section: ApplicationSettingsTabId) => {
      navigateInActiveTab(sidebarTabMapping.settings);
      setApplicationSettingsSubTabOnActiveTab(section);
    },
    [navigateInActiveTab],
  );

  const openSettingsContextMenu = useCallback(
    (event: MouseEvent<HTMLElement>, section: ApplicationSettingsTabId) => {
      openContextMenu({
        event,
        items: [
          {
            type: GlobalMenuItemsTypeEnum.OPEN_IN_NEW_TAB,
            tab: sidebarTabMapping.settings,
            onClick: () => setApplicationSettingsSubTabOnActiveTab(section),
          },
        ],
      });
    },
    [openContextMenu],
  );

  return { openSettings, openSettingsContextMenu };
}
